module.exports = __webpack_public_path__ + "static/media/nfts-bg.082846ec.png";